/**
 * Main tags filtering metadatas
 *
 * @summary tags for metadata
 * @author Dominik Haas-Artho
 *
 * Created at     : 2019-10-23 16:34:51
 * Last modified  : 2019-10-23 16:40:22
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

export default [
  /*
  { name: 'AVALANCHE', enabled: true },
  { name: 'BIOGEOGRAPHICAL', enabled: true },
  { name: 'CLIMATE', enabled: true },
*/
  { name: 'DIVERSITY', enabled: true },
  /*
  { name: 'ECONOMIC', enabled: true },
*/
  { name: 'FOREST', enabled: true },
  { name: 'HAZARD', enabled: true },
  /*
  { name: 'HUMIDITY', enabled: true },
  { name: 'ICE', enabled: true },
*/
  { name: 'LAND', enabled: true },
  { name: 'CLIMATE', enabled: true },
  /*
  { name: 'PRECIPITATION', enabled: true },
  { name: 'ROCKFALL', enabled: true },
*/
  { name: 'SNOW', enabled: true },
  /*
  { name: 'TEMPERATURE', enabled: true },
  { name: 'TREE', enabled: true },
  { name: 'VEGETATION', enabled: true },
  { name: 'WIND', enabled: true },
*/
];
